<template>
  <div class="activities">
    <div class="row">
      <div class="col-12 col-sm-6 text-center text-sm-start">
        <page-title
          v-if="viewTiles === false"
          :title="'Logboek ' + getDate()"
          icon="activities"
        ></page-title>
        <page-title
          v-if="viewTiles === true"
          :title="'Huidige activiteiten'"
          icon="activities"
        ></page-title>
      </div>
      <div class="col-12 col-sm-6  text-center text-sm-end" style="padding-top: 8px; padding-bottom: 8px">
        <span v-if="viewTiles === false">
          <date-range-select class="me-1" type="day" @changeDateRange="setDate($event.dateStart)"></date-range-select>
          <button v-on:click="showPresentChildrenOnly = !showPresentChildrenOnly" class="btn btn-secondary me-1">
            <span v-if="showPresentChildrenOnly === true">
              Toon alle
            </span>
            <span v-if="showPresentChildrenOnly === false">
              Toon aanwezig
            </span>
          </button>
        </span>
        <button v-if="getApplicationSetting('feature_flag_ipad_activities_tiles_view') === '1'" v-on:click="viewTiles = !viewTiles" class="btn btn-secondary me-1">
          <span v-if="viewTiles === false">
            Tegels
          </span>
          <span v-else-if="viewTiles === true">
            Klassiek
          </span>
        </button>
        <button v-on:click="showModal = true; formStep = 1; activity = null" class="btn btn-success">
          Nieuw
        </button>
        <span class="d-block d-sm-none" style="padding-top: 12px;"></span>
      </div>
    </div>
    <router-view
        v-if="viewTiles == false && date"
        :showPresentChildrenOnly="showPresentChildrenOnly"
        :date="date" @openModalWithChild="openModalWithChild($event)"
        @openModalWithActivity="openModalWithActivity($event)"
    />
    <activities-tiles v-else-if="viewTiles === true" @openModalWithActivity="openModalWithActivity($event)" />
    <modal v-if="showModal">
      <template v-slot:header>
        <h3 class="modal-title">
          Activiteit
          <span v-if="child">
            {{ child.first_name }}
          </span>
        </h3>
      </template>
      <template v-slot:body>
        <div style="padding: 20px">
          <activities-form :formStep="formStep" :saveActivity="saveActivity" :activity="activity" :child="child" @saveLoading="changeSaveLoading($event)" @saveActivity="saveActivity = $event; showModal = false; activity = null; child = null; saveLoading = false"></activities-form>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button type="button" class="btn btn-outline-info me-1" v-on:click="showModal = false; child = null; activity = null">Annuleren</button>
          <button v-if="formStep === 1 && (!child && !activity)" type="button" class="btn btn-info me-1" v-on:click="formStep = 2">Koppel kinderen</button>
          <button v-if="formStep === 1 && (child || activity)" type="button" class="btn btn-info" :disabled="saveLoading" v-on:click="saveActivity = true">
            <icon v-if="saveLoading" name="loading"></icon> Opslaan
          </button>
          <button v-if="formStep === 2" type="button" class="btn btn-info" :disabled="saveLoading" v-on:click="saveActivity = true">
            <icon v-if="saveLoading" name="loading"></icon> Opslaan
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import DateRangeSelect from '@/components/Date-Range-Select'
import Modal from '@/components/Modal'
import ActivitiesForm from '@/views/activities/Form'
import ActivitiesTiles from '@/views/activities/Tiles'
import Icon from '@/components/Icon'

export default {
  name: 'activities',
  components: {
    PageTitle,
    DateRangeSelect,
    Modal,
    ActivitiesForm,
    ActivitiesTiles,
    Icon
  },
  data () {
    return {
      showModal: false,
      formStep: 1,
      saveActivity: false,
      saveLoading: false,
      activity: null,
      child: null,
      showPresentChildrenOnly: true,
      date: null,
      viewTiles: false
    }
  },
  methods: {
    openModalWithChild (child) {
      this.child = child
      this.formStep = 1
      this.showModal = true
    },
    openModalWithActivity (activity) {
      this.activity = activity
      this.formStep = 1
      this.showModal = true
    },
    setDate (date) {
      this.date = date
      if (date !== this.$moment().format('YYYY-MM-DD')) {
        this.showPresentChildrenOnly = false
      }
    },
    getDate () {
      if (!this.date) {
        return ''
      }
      return this.$moment(this.date).format('ddd D MMM')
    },
    changeSaveLoading (loadingState) {
      this.saveLoading = loadingState;
      if (loadingState === false) {
         this.saveActivity = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
